var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPushsquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2260 -5 800 800",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2660.503 0c217.65 0 394.09 176.508 394.09 394.242s-176.44 394.242-394.09 394.242c-217.65 0-394.1-176.508-394.1-394.242S2442.843 0 2660.503 0Zm-257.86 154.082h509.78v484.273h-509.78V154.082zm78.05 79.065h353.68v327.131h-353.68V233.147z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushsquare);
export default __webpack_public_path__ + "static/media/pushsquare.d4c07b1d14714053de81069a3515501e.svg";
export { ForwardRef as ReactComponent };